import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ErrorModel, ResponseModel, UserImageModel, UserService as ApiUserService } from '@core/api';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { FormService } from '@core/services';
import { ToastService } from '@ui/toast';
import { UserService } from '@core/auth';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { merge, Observable, of } from 'rxjs';
import { HttpStatusCode } from '@core/enums/http-status-code';
import { throwError } from 'rxjs/internal/observable/throwError';
import { TransportModel } from '@core/api/model/transportModel';

@Component({
  selector: 'user-modal-add-traction-car',
  templateUrl: './modal-add-traction-car.component.html',
  styleUrls: ['./modal-add-traction-car.component.scss']
})
export class ModalAddTractionCarComponent implements OnInit {

  form: FormGroup;
  transport: TransportModel;
  loading = false;

  allowedPhotoTypes = [
    {
      type: UserImageModel.TypeEnum.TransportPassportFront,
      label: this.i18n('Фото оригинала свидетельства о госрегистрации ТС')
    }
  ];

  transportImages: Map<UserImageModel.TypeEnum, File> = new Map();

  imageForm: FormGroup = this.formBuilder.group({
    [UserImageModel.TypeEnum.TransportPassportFront]: [null]
  });

  constructor(
    public dialogRef: MatDialogRef<ModalAddTractionCarComponent>,
    private formBuilder: FormBuilder,
    private formService: FormService,
    private toastService: ToastService,
    private userService: UserService,
    private apiUserService: ApiUserService,
    private i18n: I18n
  ) {
    this.form = this.formBuilder.group({
      brand: [null, [Validators.required]],
      model: [null, [Validators.required]],
      number: [null, [Validators.required]],
      state_number: [null, [Validators.required]]
    });
  }

  private get invalidSelectAllPhoto() {
    return !this.allowedPhotoTypes.every(item => !!this.transportImages.get(item.type));
  }

  private get userId() {
    return this.userService.currentUserValue.id;
  }

  selectTransportFile({ image, type }) {
    this.imageForm.get(type).setValue(image);
    this.transportImages.set(type, image);
  }

  submit() {
    this.loading = true;

    this.formService.markFormGroupTouched(this.form);

    if (this.form.invalid) {
      return this.loading = false;
    }

    if (this.transport) {
      this.requestUpdateTransportData();
    } else {
      this.requestCreateTransportData();
    }
  }

  requestUpdateTransportData() {
    return this.apiUserService.userIdTransportPut(this.userId, this.transport.id, this.form.value)
      .pipe(switchMap((res) => merge(...this.requestsUpdateTransportPhoto(res.data.id))))
      .pipe(finalize(() => this.loading = false))
      .subscribe(res => {
        this.dialogRef.close(true);
      }, error => {
        this.formService.serverValidateForm(this.form, error);
      });
  }

  requestCreateTransportData() {
    return this.apiUserService.userIdTransportPost(this.userId, this.form.value)
      .pipe(switchMap((res) => {
        this.transport = res.data;
        return merge(...this.requestsUpdateTransportPhoto(res.data.id))
      }))
      .pipe(finalize(() => this.loading = false))
      .subscribe(res => {
        this.dialogRef.close(true);
      }, error => {
        this.formService.serverValidateForm(this.form, error);
      });
  }

  requestsUpdateTransportPhoto(transportId: number) {
    const requests: Array<Observable<ResponseModel<any>>> = [];

    this.transportImages.forEach((image, type) => {
      requests.push(this.apiUserService.userIdTransportIdImagePost(this.userId, transportId, {
          image,
          type
        }).pipe(catchError(err => {
          if (err.status === HttpStatusCode.UNPROCESSABLE_ENTITY) {
            err.errors[type] = err.errors && err.errors.image;

            this.formService.serverValidateForm(this.imageForm, err);
          }

          return throwError(err);
        }))
      );
    });

    if(!requests.length) {
      requests.push(of({
        success: true,
        data: null
      }));
    }

    return requests;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  ngOnInit() {
  }

}
